import { Component, input } from '@angular/core'

export type IconName =
  | 'menu'
  | 'close'
  | 'home'
  | 'wall'
  | 'clipboard'
  | 'newspaper'
  | 'medal'
  | 'folder'
  | 'poll'
  | 'chevron-down'
  | 'logout'
  | 'user'
  | 'star'
  | 'eye'
  | 'eye-off'
  | 'heart'
  | 'comment'
  | 'image'
  | 'upload'
  | 'trash'
  | 'check'

@Component({
  selector: 'app-icon',
  host: {
    '[style.display]': "'inline-block'",
    '[style.width.px]': 'size()',
    '[style.height.px]': 'size()'
  },
  template: `
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      width="100%"
      height="100%"
      aria-hidden="true">
      @switch (name()) {
        @case ('menu') {
          <path d="M4 6h16M4 12h16M4 18h16" />
        }
        @case ('close') {
          <path d="M6 6l12 12M18 6L6 18" />
        }
        @case ('home') {
          <path d="M3 11.5 12 4l9 7.5" />
          <path d="M5 10v9a1 1 0 0 0 1 1h4v-6h4v6h4a1 1 0 0 0 1-1v-9" />
        }
        @case ('wall') {
          <rect
            x="3"
            y="4"
            width="18"
            height="16"
            rx="2" />
          <path d="M3 9h18M9 9v11" />
        }
        @case ('clipboard') {
          <rect
            x="6"
            y="4"
            width="12"
            height="17"
            rx="2" />
          <path d="M9 4V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1M9 12l2 2 4-4" />
        }
        @case ('newspaper') {
          <path d="M4 5h13a2 2 0 0 1 2 2v12a1 1 0 0 1-1 1H6a2 2 0 0 1-2-2V5Z" />
          <path d="M4 5v13a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2ZM8 9h7M8 13h7M8 17h4" />
        }
        @case ('medal') {
          <circle
            cx="12"
            cy="15"
            r="6" />
          <path d="M9 10 6 3h3l3 5 3-5h3l-3 7" />
        }
        @case ('folder') {
          <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z" />
        }
        @case ('poll') {
          <path d="M4 20V10M12 20V4M20 20v-7" />
        }
        @case ('chevron-down') {
          <path d="M6 9l6 6 6-6" />
        }
        @case ('logout') {
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" />
        }
        @case ('user') {
          <circle
            cx="12"
            cy="8"
            r="4" />
          <path d="M4 21c0-4.4 3.6-8 8-8s8 3.6 8 8" />
        }
        @case ('star') {
          <path
            d="M12 2l2.9 6.6 7.1.6-5.4 4.7 1.7 7-6.3-3.9L5.7 21l1.7-7-5.4-4.7 7.1-.6L12 2Z"
            fill="currentColor"
            stroke="none" />
        }
        @case ('eye') {
          <path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7-10-7-10-7Z" />
          <circle
            cx="12"
            cy="12"
            r="3" />
        }
        @case ('eye-off') {
          <path d="M3 3l18 18M10.6 10.6a3 3 0 0 0 4.24 4.24M9.9 4.24A10.6 10.6 0 0 1 12 4c6.4 0 10 7 10 7a17.6 17.6 0 0 1-3.2 4.15M6.5 6.5C4 8.1 2 11 2 11s3.6 7 10 7a9.7 9.7 0 0 0 3.1-.5" />
        }
        @case ('heart') {
          <path d="M12 20.5s-7.5-4.6-10-9.3C.5 8 2 4.5 5.5 4c2-.3 3.7.6 4.9 2.2L12 8l1.6-1.8C14.8 4.6 16.5 3.7 18.5 4c3.5.5 5 4 3.5 7.2-2.5 4.7-10 9.3-10 9.3Z" />
        }
        @case ('comment') {
          <path d="M4 5h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H9l-4.4 3.3A.6.6 0 0 1 3 19.8V17a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Z" />
        }
        @case ('image') {
          <rect
            x="3"
            y="4"
            width="18"
            height="16"
            rx="2" />
          <circle
            cx="9"
            cy="10"
            r="1.8" />
          <path d="m4 17 5-5 4 4 3-3 4 4" />
        }
        @case ('upload') {
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
          <path d="M17 8l-5-5-5 5" />
          <path d="M12 3v12" />
        }
        @case ('trash') {
          <path d="M3 6h18" />
          <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
          <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
          <path d="M10 11v6" />
          <path d="M14 11v6" />
        }
        @case ('check') {
          <path d="M20 6L9 17l-5-5" />
        }
      }
    </svg>
  `
})
export class Icon {
  name = input.required<IconName>()
  size = input<number>(20)
}
